import 'globals';

(function($, window, document, pageLoadedQueue) {
    pageLoadedQueue.push(function() {
        if ($('.fileItem').length) {

            // Download File
            $('.downloadFile').click(function () {
                var nodeIdentifier = $(this).data('identifier');
                var downloadUrl = $(this).data('downloadurl');
                $.ajax({
                    type: 'POST',
                    url: _AVENCY_BASE_actions.DownloadFile,
                    data: {
                        fileInformation: {
                            nodeIdentifier: nodeIdentifier,
                            downloadUrl: downloadUrl
                        },
                        __csrfToken: _AVENCY_NSE_csrfToken
                    },
                    dataType: 'json'
                });
            });

            // Delete File
            $('.deleteFile').click(function () {
                var inputData = $(this).data('identifier');
                $.ajax({
                    type: 'POST',
                    url: _AVENCY_BASE_actions.RemoveFile,
                    data: {
                        fileInformation: inputData,
                        __csrfToken: _AVENCY_NSE_csrfToken
                    },
                    dataType: 'json',
                    success: function (data) {
                        document.getElementById('node-' + data.nodeIdentifier).remove();
                    }
                });
            });
        }
    });
})(jQuery, window, document, window.pageLoadedQueue);
